import Vue from 'vue'
import Router from 'vue-router'
import Index from 'components/index'
import Problems from 'components/Problems'
import Solutions from 'components/Solutions'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:lang',
      name: 'Index',
      component: Index
    },
    {
      path: '/:lang/problems',
      name: 'Problems',
      component: Problems
    },
    {
      path: '/:lang/solutions',
      name: 'Solutions',
      component: Solutions
    },
    {
      path: '*',
      component: Index
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js